export default "__VITE_ASSET__BWLj3I0y__"